import {NamedValue} from "@2d-front-monorepo/core";
import {JSX} from "react";
import {useControlId} from "../helpers/useControlId";
import OptionGroup from "../HtmlControls/OptionGroup";
import {MvvmControlProps} from "./MvvmControlProps";
import {useMvvmFieldSubscription} from "./MvvmDataProvider";
import {useOptionItemMap} from "./useItemMap";
import {useMvvmSingleSelection} from "./useMvvmSelection";
import {useRegisterValidation} from "./useRegisterValidation";

export interface MvvmOptionGroupEntry<TValue> extends NamedValue<TValue> {
	disabled?: boolean;
}

export interface MvvmOptionGroupProps<T extends object = never, TValue = never> extends MvvmControlProps<T, TValue> {
	items: MvvmOptionGroupEntry<TValue>[];
}

export default function MvvmOptionGroup<T extends object = never, TValue = never>(props: MvvmOptionGroupProps<T, TValue>): JSX.Element {
	const {
		context,
		property,
		id,
		label,
		items,
		column,
		hidden,
		disabled,
		validation,
		onChange,
		onBlur
	} = props;

	const controlId = useControlId(id);
	const itemMap = useOptionItemMap(items);
	const {selectedValues, onChangeInternal} = useMvvmSingleSelection(context, property, items, onChange);

	useRegisterValidation(context, property, controlId, hidden, validation);
	useMvvmFieldSubscription(context, property);

	if (hidden) {
		return <></>;
	}

	return <OptionGroup label={label}
	                    name={controlId}
	                    items={itemMap}
	                    values={selectedValues}
	                    disabled={disabled}
	                    column={column}
	                    onChange={onChangeInternal}
	                    onBlur={onBlur}/>;
}
